import { render } from "./pagefore.vue?vue&type=template&id=489b98e3&scoped=true"
import script from "./pagefore.vue?vue&type=script&lang=js"
export * from "./pagefore.vue?vue&type=script&lang=js"

import "./pagefore.vue?vue&type=style&index=0&id=489b98e3&lang=less&scoped=true"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489b98e3"]])

export default __exports__